import { render } from "./PreadmissionNotesRow.vue?vue&type=template&id=38cd858d"
import script from "./PreadmissionNotesRow.ts?vue&type=script&lang=js&external"
export * from "./PreadmissionNotesRow.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__